import React, { Component } from 'react';
import { Multiselect } from 'multiselect-react-dropdown';
import TextareaAutosize from 'react-textarea-autosize';

/* Images */
import tiana2 from '../../assets/tianas2.jpg';

/* Tiana Recipe */
class TianaRecipe extends Component {
    constructor(props) {
        super(props);
        this.state = {
            section: 0,
            editSummary: false
        }

        /* Refs */
        this.sliderRef = React.createRef();

        this.typeRef = React.createRef();
        this.cuisineRef = React.createRef();
        this.dietRef = React.createRef();

        /* Function */
        this.changeSection = this.changeSection.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleListChange = this.handleListChange.bind(this);
        this.handleHtmlChange = this.handleHtmlChange.bind(this);
        this.changeListElement = this.changeListElement.bind(this);
        this.controlSlider = this.controlSlider.bind(this);
        this.closeSlider = this.closeSlider.bind(this);
    }

    changeSection(id){
        var self = this;
        this.setState({ section: id }, () =>{
            self.controlSlider(id)
        });
    }

    handleChange(e){
        try {
            var name = e.target.name;
            var value = e.target.value;
            var tmpData = this.props.selectedRecipe;

            tmpData[name] = value;
            this.props.handleChange(tmpData);
        }
        catch(ex){
            console.log("[Error] Handling Change: ",ex);
        }
    }

    handleListChange(ref){
        try {
            var name = ref.current.props.name;
            var value = ref.current.getSelectedItems();
            var tmpData = this.props.selectedRecipe;
            tmpData[name] = value;
            this.props.handleChange(tmpData);
        }
        catch(ex){
            console.log("[Error] Handling Change: ",ex);
        }
    }

    handleHtmlChange(e){
        try {
            var name = e.target.getAttribute('name');
            var value = e.target.innerHTML;
            var tmpData = this.props.selectedRecipe;

            if(name === "fullInstructions" || name === "ingredients" || name === "wine"){
                var loc = e.target.getAttribute('loc');
                var section = e.target.getAttribute('section');
                value = (name === "ingredients" ? e.target.value : value);

                if(section !== "") { tmpData[name][loc][section] = value; }
                else { tmpData[name][loc] = value; }
            }
            else {
                tmpData[name] = value;
            }            
            
            this.props.handleChange(tmpData);
        }
        catch(ex){
            console.log("[Error] Handling HTML Change: ",ex);
        }
    }

    changeListElement(type, list, loc){
        try {
            var tmpData = this.props.selectedRecipe;

            if(type === "add") {
                if(list === "instruction"){
                    tmpData.fullInstructions.push({number: tmpData.fullInstructions.length+1, step:"Instruction" });
                }
                else if(list === "ingredient"){
                    tmpData.ingredients.push({ name: "", amount:0, unit:"", originalString:"" });
                }
                else if(list === "wine"){
                    tmpData.winePairing.push("NAME");
                }
            }
            else {
                if(list === "instruction"){
                    tmpData.fullInstructions.splice(loc,1);
                }
                else if(list === "ingredient"){
                    tmpData.ingredients.splice(loc,1);
                }
                else if(list === "wine"){
                    tmpData.winePairing.splice(loc,1);
                }
            }
            

            this.props.handleChange(tmpData);
        }
        catch(ex){
            console.log("Error Adding Element: ",ex);
        }
    }

    controlSlider(id){
        try {
            if(this.sliderRef.current){
                var scrollSz = (id/2) * (this.sliderRef.current.clientWidth ? this.sliderRef.current.clientWidth : 1);
                this.sliderRef.current.scrollLeft = scrollSz;
            }
        }
        catch(ex){
            console.log("Error with slider control: ", ex);
        }
    }

    closeSlider(){
        var self = this;
        try {
            this.props.closeSlider();
            this.setState({ section: 0, editSummary: false }, ()=>{
                self.controlSlider(0);
            });
        }
        catch(ex){
            console.log(" [Error] closing slider: ",ex);
        }
    }
    componentDidMount(){
        this.controlSlider(this.state.section);
    }

    render(){   
        return(
            <div>
                <div className="slider-title">
                    <div className="btn-container">
                        <div className="tro-btn btn" onClick={this.props.saveRecipe}>
                            <div className="btn-txt">Save</div>
                            <div className="btn-icon"><i className="fas fa-save" /></div>
                        </div>
                    </div>
                    <i className="title-icon fas fa-times" onClick={this.closeSlider}/>
                </div>

                <div className="slider-miniNav">
                    <div className={"nav-item"+ (this.state.section == 0 ? " sel" : "")} onClick={()=> this.changeSection(0)}>
                        <i className="fas fa-utensils" />
                        <span>Overview</span>                            
                    </div>
                    <div className={"nav-item"+ (this.state.section == 1 ? " sel" : "")} onClick={()=> this.changeSection(1)}>
                        <i className="fas fa-list-ul" />
                        <span>Ingredients</span>
                    </div>
                    <div className={"nav-item"+ (this.state.section == 2 ? " sel" : "")} onClick={()=> this.changeSection(2)}>
                        <i className="fas fa-book-reader" />
                        <span>Instructions</span>
                    </div>
                </div>
                {this.props.selectedRecipe && 
                    <div className="slider-body" ref={this.sliderRef}>
                        <div className="body-col sz-6 img-title">
                            <img className="img-title" src={(this.props.selectedRecipe.image ? this.props.selectedRecipe.image : tiana2 )} alt="recipe visual" />
                            <div className="title-content">
                                <div className="title-meta">
                                    {this.props.selectedRecipe._id &&
                                        <div className="meta-info fav" onClick={this.props.removeRecipe}>
                                            <i className="far fa-thumbs-up"></i>
                                            <span>Favorite</span>
                                        </div>
                                    }
                                    <div className="meta-info">
                                        <i className="far fa-clock"></i>
                                        <div><span name="readyInMinutes" contentEditable onInput={this.handleHtmlChange} dangerouslySetInnerHTML={{__html: this.props.selectedRecipe.readyInMinutes}} /> mins</div>
                                    </div>
                                    <div className="meta-info">
                                        <i className="far fa-star-half"></i>
                                        <span name="score" contentEditable onInput={this.handleHtmlChange} dangerouslySetInnerHTML={{__html: this.props.selectedRecipe.score}}/>
                                    </div>
                                </div>
                                <h1><TextareaAutosize name="title" value={this.props.selectedRecipe.title} onChange={this.handleChange} /></h1>
                            </div>
                        </div>
                        <div className="body-col sz-4">
                            <div className="col-block c0 flx flow">
                                <div className="tags">
                                    {/* Types */}
                                    <div className="tag-block">
                                        <div className="tag-title">Types</div>
                                        <Multiselect id="tag-select" ref={this.typeRef} name="dishTypes" placeholder="" options={this.props.dishTypes} selectedValues={this.props.selectedRecipe.dishTypes} avoidHighlightFirstOption={true} isObject={false} onSelect={() => this.handleListChange(this.typeRef)} onRemove={() => this.handleListChange(this.typeRef)}/> 
                                    </div>
                                    {/* Cuisines */}
                                    <div className="tag-block">
                                        <div className="tag-title">Cuisines</div>
                                        <Multiselect id="tag-select" ref={this.cuisineRef} name="cuisines" placeholder="" options={this.props.cuisines} selectedValues={this.props.selectedRecipe.cuisines} avoidHighlightFirstOption={true} isObject={false} onSelect={() => this.handleListChange(this.cuisineRef)} onRemove={() => this.handleListChange(this.cuisineRef)}/> 
                                    </div>
                                    {/* Diets */}
                                    <div className="tag-block">
                                        <div className="tag-title">Diets</div>
                                        <Multiselect id="tag-select" ref={this.dietRef} name="diets" placeholder="" options={this.props.diets} selectedValues={this.props.selectedRecipe.diets} avoidHighlightFirstOption={true} isObject={false} onSelect={() => this.handleListChange(this.dietRef)} onRemove={() => this.handleListChange(this.dietRef)}/> 
                                    </div>
                                </div>
                            </div>
                            <div className="col-block c2 wl flx scroll">
                                <div className="edit-btn" onClick={()=> this.setState({ editSummary: !this.state.editSummary })}>
                                    {this.state.editSummary ? 
                                        <i className="fas fa-glasses" /> :
                                        <i className="fas fa-edit" />
                                    }
                                </div>
                                {this.state.editSummary ? 
                                    <TextareaAutosize className="summary" name="summary" value={this.props.selectedRecipe.summary} onChange={this.handleChange} /> :
                                    <div className="summary" name="summary" dangerouslySetInnerHTML={{__html: this.props.selectedRecipe.summary}}/>
                                }
                            </div>
                        </div>
                        <div className="body-col sz-5">
                            <div className={"col-block c1 lrg scroll" + (this.state.section == 2 ? " wr" :"")}>
                                {/* Ingredients */}
                                <div className={"txt-section ingredients slide-section" + (this.state.section == 1 ? " active" :"")}>
                                    <div className="section-title">
                                        <span>Ingredients</span>
                                        <div className="btn-container">
                                            <div className="tro-btn btn" onClick={()=> this.changeListElement("add", "ingredient",0)}>
                                                <div className="btn-txt">Add</div>
                                                <div className="btn-icon"><i className="fas fa-plus-circle" /></div>
                                            </div>
                                        </div>
                                    </div>
                                    {this.props.selectedRecipe.ingredients.map((item,i) =>
                                        <div className="ingredient" key={i}>
                                            <div className="step-icon" onClick={()=> this.changeListElement("remove", "ingredient",i)}>
                                                <i className="fas fa-utensils base" />
                                                <i className="fas fa-minus hover" />
                                            </div>
                                            <input className="sm" type="text" value={item.amount} name="ingredients" section="amount" loc={i} onChange={this.handleHtmlChange}/>
                                            <input className="" type="text" value={item.unit} name="ingredients" section="unit" loc={i} onChange={this.handleHtmlChange}/>
                                            <input className="" type="text" value={item.name} name="ingredients" section="name" loc={i} onChange={this.handleHtmlChange}/>
                                        </div>
                                    )}
                                </div>

                                {/* Instructions */}
                                <div className={"instructions slide-section" + (this.state.section == 2 ? " active" :"")}>
                                    <div className="section-title">
                                        <span>Instructions</span>
                                        <div className="btn-container">
                                            <div className="tro-btn btn" onClick={()=> this.changeListElement("add", "instruction",0)}>
                                                <div className="btn-txt">Add</div>
                                                <div className="btn-icon"><i className="fas fa-plus-circle" /></div>
                                            </div>
                                        </div>
                                    </div>
                                    {this.props.selectedRecipe.fullInstructions.map((item,i) =>
                                        <div className="instruction" key={i}>
                                            <div className="step-section">
                                                <div className="step-icon" onClick={()=> this.changeListElement("remove", "instruction",i)}>
                                                    <span className="base">{i+1}</span>
                                                    <i className="fas fa-minus hover" />
                                                </div>
                                            </div>
                                            <div className="step-section flx">
                                                <span name="fullInstructions" section="step" loc={i} contentEditable onInput={this.handleHtmlChange} dangerouslySetInnerHTML={{__html: item.step}} />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-block c0 flx">
                                {/* Wines */}                                
                                <div className={"wine-list slide-section" + (this.state.section == 1 ? " active" :"")}>
                                    <div className="section-title">
                                        <span>Wine Paring</span>
                                        <div className="btn-container">
                                            <div className="tro-btn btn" onClick={()=> this.changeListElement("add", "wine",0)}>
                                                <div className="btn-txt">Add</div>
                                                <div className="btn-icon"><i className="fas fa-plus-circle" /></div>
                                            </div>
                                        </div>
                                    </div>
                                    {this.props.selectedRecipe.winePairing.map((item,i) =>
                                        <div className="wine-pill" key={i}>
                                            <span name="wine" section="" loc={i} contentEditable onInput={this.handleHtmlChange} dangerouslySetInnerHTML={{__html: item}} />
                                            <i className="far fa-times-circle" onClick={()=> this.changeListElement("remove", "wine",i)}/>
                                        </div>
                                    )}
                                </div>

                                {/* Website */}
                                <div className={"site-list slide-section" + (this.state.section == 2 ? " active" :"")}>
                                    <div className="section-title">
                                        <span>Websites</span>
                                    </div>
                                    <div className="site-list-container">
                                        <div className="site-btn">
                                            <input value={this.props.selectedRecipe.sourceUrl} name="sourceUrl" placeholder="Site URL 1" autoComplete="off" onChange={this.handleChange} />
                                            <a href={this.props.selectedRecipe.sourceUrl} target="_blank" className="site-icon"><span>Visit Site</span><i className="fas fa-globe" /></a>
                                        </div>
                                        <div className="site-btn">
                                            <input value={this.props.selectedRecipe.spoonacularSourceUrl} name="spoonacularSourceUrl" placeholder="Site URL 2" autoComplete="off" onChange={this.handleChange} />
                                            <a href={this.props.selectedRecipe.spoonacularSourceUrl} target="_blank" className="site-icon"><span>Visit Site</span><i className="fas fa-globe" /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="body-col sz-5">                            
                            <div className="col-block fill flx">
                                <img src={(this.props.selectedRecipe.image ? this.props.selectedRecipe.image : tiana2 )} alt="recipe visual" />
                            </div>
                            <div className="col-block c2">
                                <h1 className="ctr" >{this.props.selectedRecipe.title}</h1>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }

}

export default TianaRecipe;